import {
  useTranslations as useCoreTranslations,
  useTranslate as useCoreTranslate,
  setLocale as setCoreLocale,
  t as coreTranslate,
} from '@locale/translate';

import localeEN from './en.js';
import localeIS from './is.js';

type LocaleCode = 'is' | 'en';

export type TranslationKey = keyof typeof localeEN;

export const useTranslations = () => {
  useCoreTranslations({
    translations: { is: localeIS, en: localeEN },
    persistKey: 'admin-locale',
  });
};

export const t = coreTranslate<TranslationKey>;
export const useTranslate = useCoreTranslate<TranslationKey, LocaleCode>;
export const setLocale = setCoreLocale<LocaleCode>;

export * from './key-maps';
